import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'

import App from './App'
import GlobalComponents from './components'
import rules from './rules'
import Router from './app.router'
import Auth from './app.auth'
import api from './app.api'
import AppFilters from './app.filters'
import { permissions, rigths, permissionsTable } from './app.structures'

import 'vuetify/dist/vuetify.min.css'
import './styles/style.css'

Vue.use(Vuetify, {
  theme: {
    primary: "#009688",
    secondary: "#26A69A",
    accent: "#FF9800",
    error: "#f44336",
    warning: "#ffeb3b",
    info: "#2196f3",
    success: "#4caf50"
  }
})

const auth = Auth(api)

Vue.mixin({
  data: () => ({
    get Auth() {
      return auth
    },
    get Api() {
      return api
    },
    get Rules() {
      return rules
    },
    get Permissions() {
      return permissions
    },
    get PermissionsTable() {
      return permissionsTable
    }
  })
})

GlobalComponents.forEach((global) => {
  Vue.component(global.tag, global.component)
});
AppFilters.forEach((filter) => {
  Vue.filter(filter.name, filter.function)
})

Vue.config.productionTip = false

const router = Router(Vue, auth)

api.clientAction = (action) => {
  if (action != 'logout') return
  router.push('/logout')
}

auth.checkLogin().then(() => {
  new Vue({
    render: h => h(App),
    router
  }).$mount('#app')
})